import { Pipe, PipeTransform } from '@angular/core';
import { StatusService } from '@core/services/status.service';
import { FormForApplicantForUI, MyApplicationForm } from '@features/configure-forms/form.typing';

@Pipe({
  name: 'gcFormStatusDate',
  pure: true
})
export class FormStatusDatePipe implements PipeTransform {

  constructor (
    private statusService: StatusService
  ) { }

  transform (
    form: MyApplicationForm|FormForApplicantForUI
  ) {
    if ('status' in form) {
      return this.statusService.getFormStatusDate(
        form.status,
        form.updatedDate,
        form.submissionDate,
        form.statusUpdatedDate
      );
    } else {
      return this.statusService.getFormStatusDate(
        form.applicationFormStatusId,
        form.updatedDate,
        form.submittedDate,
        form.statusUpdatedDate
      );
    }
  }
}
